export default () => ({
  /** @type {number | null} */
  index: null,
  /** @type {string[]} */
  items: [],
});
